import * as React from 'react';

function StarEmpty(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M12 5.581l1.65 4.951.114.342h5.665l-4.28 3.032-.303.214.117.352 1.642 4.925-4.316-3.056-.289-.205-.289.204-4.316 3.058 1.642-4.927.117-.351-.302-.215-4.28-3.03H10.236l.114-.342L12 5.581z"
        stroke="currentColor"
      />
    </svg>
  );
}

export default StarEmpty;
